<template>
  <!-- 上方主体 服务-->
  <div class="container_top" id="topCont" @mouseover="barNum = 0">
    <!-- 轮播图 -->
    <div class="topTitCont">
      
      <img style="width: 100%;display: block;" src="https://zhiyinfuzheng.oss-cn-shanghai.aliyuncs.com/we8rsbluki13za44du13.png" alt="" />
      <div class="cont_topTil">软件产品</div>
      <div class="cont_topShad">software product</div>
    </div>
    <!-- 服务 -->
    <div class="overviewApp" id="overviewApp">
      <div class="ove_compe_tit">软件产品介绍</div>
      <div class="ove_compe_txt">
        秉承“科技赋能，护佑安全”的理念，
        致力于自主可控关键核心技术研发为己任,着眼<br />
        新一代网络信息基础设施及重要信息系统安全保障为使命，
        面向智慧型生产与生活提供全方位的网络与信息安全服务。
      </div>
      <div class="oveCont">
        <div
          class="oveCont_card"
          v-for="(item, index) in softwareList"
          :key="index"
          @click="gosoftware(item)"
        >
          <div class="card_left">
            <img :src="item.img" />
          </div>
          <div class="cardBot_txt">
            <div class="card_Tit">{{ item.tit }}</div>
            <!-- <div>Service name</div> -->
          </div>
        </div>

        
      </div>
    </div>
  </div>
</template>
      
<script>
export default {
  props: { switchNum: String },
  components: {},
  data() {
    return {
      swiperOption: {
        loop: true,
        // centeredSlides: true,
        slidesPerView: 1,
        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false,
        // },
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          paginationClickable: true,
        },
      },
      tapHomeFlg: false,
      tapNum: 0,
      tapFlg: "1",
      // softwareList: [
      //   {
      //     tit: "京数应用商店",
      //     url: "systemProduct/vargoAppStore",
      //     img: require("@/assets/aboutUs/software01.png"),
      //     idNum: "5-1",
      //   },
      //   {
      //     tit: "VTIME行政办公",
      //     url: "systemProduct/vargoAppStore",
      //     img: require("@/assets/aboutUs/software03.png"),
      //     idNum: "5-2",
      //   },
      //   {
      //     tit: "密语",
      //     url: "systemProduct/vargoAppStore",
      //     img: require("@/assets/aboutUs/software02.png"),
      //     idNum: "5-3",
      //   },
      //   {
      //     tit: "密信",
      //     url: "systemProduct/vargoAppStore",
      //     img: require("@/assets/aboutUs/software04.png"),
      //     idNum: "5-4",
      //   },
      //   {
      //     tit: "安全相册",
      //     url: "systemProduct/vargoAppStore",
      //     img: require("@/assets/aboutUs/software06.png"),
      //     idNum: "5-5",
      //   },
      //   {
      //     tit: "平行线-资源管理",
      //     url: "systemProduct/vargoAppStore",
      //     img: require("@/assets/aboutUs/software11.png"),
      //     idNum: "5-6",
      //   },
      //   {
      //     tit: "安全对讲",
      //     url: "systemProduct/vargoAppStore",
      //     img: require("@/assets/aboutUs/software08.png"),
      //     idNum: "5-7",
      //   },
      //   {
      //     tit: "音视会议",
      //     url: "systemProduct/vargoAppStore",
      //     img: require("@/assets/aboutUs/software09.png"),
      //     idNum: "5-8",
      //   },
      //   {
      //     tit: "安全传输",
      //     url: "systemProduct/vargoAppStore",
      //     img: require("@/assets/aboutUs/software07.png"),
      //     idNum: "5-9",
      //   },
      //   {
      //     tit: "京数云",
      //     url: "systemProduct/vargoAppStore",
      //     img: require("@/assets/aboutUs/software10.png"),
      //     idNum: "5-0",
      //   },
      // ],
    };
  },
  computed: {},
  watch: {
    switchNum(curVal, oldVal) {
      // console.log("测试switchNum",curVal, oldVal);

      if (curVal == 3) {
        document
          .getElementById("topCont")
          .scrollIntoView({ behavior: "smooth" });
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  activated() {
    console.log(this.switchNum);
  },
  created() {
    if (this.switchNum == 3) {
      document.getElementById("topCont").scrollIntoView({ behavior: "smooth" });
    }
  },
  methods: {
    tapClic(row) {
      this.tapFlg = row;
      if (row == 1) {
        document
          .getElementById("overviewApp")
          .scrollIntoView({ behavior: "smooth" });
      }
      if (row == 2) {
        document
          .getElementById("featAdvan")
          .scrollIntoView({ behavior: "smooth" });
      }
      if (row == 3) {
        document
          .getElementById("customTerminal")
          .scrollIntoView({ behavior: "smooth" });
      }
      if (row == 4) {
        document
          .getElementById("customerValue")
          .scrollIntoView({ behavior: "smooth" });
      }
    },
    handleScroll() {
      if (this.$refs.custom && this.$refs.custom.offsetTop) {
        // console.log(
        //   "测试滚动条",
        //   window.scrollY,
        //   this.$refs.custom.offsetTop,
        //   this.switchNum,
        //   document.body.scrollTop
        // );

        if (window.scrollY > 650) {
          var scrollTop =
            window.scrollY ||
            document.documentElement.scrollTop ||
            document.body.scrollTop;
          var scroll = scrollTop - this.i;
          this.i = scrollTop;
          if (scroll < 0) {
            this.tapHomeFlg = false;
            // console.log("up");
          } else {
            // console.log("down");
            this.tapHomeFlg = true;
            this.tapNum = 1;
          }
        } else {
          this.tapHomeFlg = false;
        }
        this.$emit("switchflg", "0");
      }
    },
    gosoftware(row){
      this.$router.push({
          name: row.url,
          params: {},
        });
        this.$store.commit("changeTabCheck", {
          idNum: row.idNum,
          sumName: '',
        });
        this.$store.state.enterp_somFlg = "";
    },
  },
};
</script>
      
<style lang="less" scoped>
.container_top {
  width: 100%;
  .topTitCont{
    position: relative;
    display: flex;
    justify-content: center;
  }
  .cont_topTil {
width: 100%;
    max-width: 1200px;
    margin: 0px auto;
    position: absolute;
    bottom: 50%;
    //left: 13%;
    font-size: 46px;
    font-weight: 600;
    color: white;
  }
  .cont_topShad {
    width: 100%;
    max-width: 1200px;
    margin: 0px auto;
    opacity: 0.8;
    position: absolute;
    bottom: 46%;
    //left: 13%;
    font-size: 18px;
    color: white;
  }
}

// 头部tap
.tapCont {
  position: relative;
  background: #fff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  .tapAll {
    width: 100%;
    max-width: 1200px;
    margin: 0px auto;
    height: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .tapOne {
    cursor: pointer;
    font-size: 20px;
    margin: 20px;
  }
  .colr {
    // background: linear-gradient(360deg, #003365 0%, #048799 100%);
    position: relative;
    color: #048799;
  }
  .colr::before {
    content: "";
    height: 3px;
    background: #048799;
    position: absolute;
    top: 44px;
    width: 100%;
  }
  @keyframes arise {
    0% {
      top: -80px;
    }
    100% {
      top: 0px;
    }
  }
  .tapHome {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0px;
    z-index: 9999;
    width: 100%;
    background: white;
    height: 103px;
    animation: arise 0.5s ease-out;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  }
  .tapPackUp {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: -130px;
    animation: packUp 0.5s ease-out;
  }
  @keyframes packUp {
    0% {
      position: fixed;
      z-index: 9999;
      width: 100%;
      background: white;
      height: 80px;
      top: 0px;
    }
    100% {
      position: fixed;
      z-index: 9999;
      width: 100%;
      background: white;
      height: 80px;
      top: -80px;
    }
  }
  .tapPack {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: -130px;
  }
}

// 服务
.overviewApp {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 80px;
  // height: 500px;
  .ove_compe_tit {
    font-size: 32px;
    font-weight: 600;
    color: #151a23;
    position: relative;
    margin-bottom: 20px;
    // width: 130px;
  }
  // .ove_compe_tit::before {
  //   content: "";
  //   height: 1px;
  //   background: #151a23;
  //   position: absolute;
  //   top: 60px;
  //   width: 100%;
  // }
  .ove_compe_fy {
    font-size: 20px;
    color: #8a8c91;
    // 文字渐变
    // background: linear-gradient(to top, #ffffff 0%, #ffffff 25%, #f4ca80 100%);
    // background-clip: text;
    // -webkit-background-clip: text;
    // -webkit-text-fill-color: transparent;
  }
  .ove_compe_txt {
    width: 56%;
    margin-top: 50px;
    text-align: center;
  }
  .oveCont {
    display: flex;
    // justify-content: center;
    align-items: center;
    padding: 80px 0 20px 0;
    // width: 1470px;
    width: 1436px;
    flex-wrap: wrap;
    width: 100%;
    max-width: 1230px;
  }
  .oveCont_card {
    // background: #f3f8ff;
    // padding: 53px;
    // width: 38%;
    margin: 20px;
    display: flex;
    justify-content: center;
    // align-items: center;
    flex-direction: column;
    // width: 326px;
    width: 370px;
    height: 226px;
    cursor: pointer;
  }
  .oveCont_card:hover {
    // background: #04758e;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  }
  // .oveCont_card:hover .ove_txt {
  //   background: linear-gradient(180deg, #fff -54%, rgba(4, 117, 142, 0) 100%);
  //   background-clip: text;
  //   -webkit-background-clip: text;
  //   -webkit-text-fill-color: transparent;
  // }
  // .oveCont_card:hover .cardBot_txt {
  //   color: #fff;
  // }
  // .oveCont_card:hover .cardImgone {
  //   display: none;
  // }
  // .oveCont_card:hover .cardImgtwo {
  //   display: block;
  // }
  .cardImgtwo {
    display: none;
  }

  .card_left {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  .card_left img {
    width: 30%;
  }
  .cardBot_txt {
    text-align: center;
    // margin-right: 15px;
    margin-top: 25px;
  }

  .card_Tit {
    font-size: 19px;
    font-weight: 600;
  }
  .ove_txt {
    font-family: SimHei;
    // background: linear-gradient(to top, #F3F8FF 0%, #F3F8FF 45%, #04758E 100%);
    background: linear-gradient(
      180deg,
      #04758e -54%,
      rgba(4, 117, 142, 0) 100%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 90px;
    font-weight: 700;

    // position: absolute;
    // top: 0;
    // right: 15px;
  }
}
// 方案优势
.featAdvan {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 80px 85px;
  .feat_compe_tit {
    font-size: 32px;
    font-weight: 600;
    color: #151a23;
    position: relative;
    margin-bottom: 20px;
  }
  .feat_compe_tit::before {
    content: "";
    height: 1px;
    background: #151a23;
    position: absolute;
    top: 60px;
    width: 100%;
  }
  .feat_compe_fy {
    font-size: 20px;
    color: #8a8c91;
  }
  .featCont {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 80px 0 20px 0;
    height: 520px;
  }
  .feat_card {
    margin: 0 20px;
  }
  .feat_card img {
    width: 100%;
    margin-bottom: -4px;
  }
  .feat_card:hover {
    // margin-bottom: 100px;
    animation: cardHover 0.5s ease-out;
    animation-iteration-count: inherit;
    animation-fill-mode: both;
  }
  @keyframes cardHover {
    0% {
      padding-bottom: 0px;
      // opacity: 0;
    }
    100% {
      padding-bottom: 100px;
      // opacity: 1;
    }
  }

  .feat_card img {
    width: 100%;
    margin-bottom: -4px;
  }
  .featBot_cont {
    background: #fff;
    padding: 25px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
  }
  .feat_Tit {
    margin-bottom: 20px;
    font-size: 22px;
    font-weight: 500;
  }
}

// 定制化智能安全终端
.customTerminal {
  background: #f3f8ff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .custom_compe_tit {
    font-size: 32px;
    font-weight: 600;
    color: #151a23;
    position: relative;
    margin-bottom: 20px;
  }
  .custom_compe_tit::before {
    content: "";
    height: 1px;
    background: #151a23;
    position: absolute;
    top: 60px;
    width: 100%;
  }
  .custom_compe_fy {
    font-size: 20px;
    color: #8a8c91;
  }
}
// 云平台服务
.customerValue {
  background: #f3f8ff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 80px 105px;
  .cust_compe_tit {
    font-size: 32px;
    font-weight: 600;
    color: #151a23;
    position: relative;
    margin-bottom: 20px;
  }
  .cust_compe_tit::before {
    content: "";
    height: 1px;
    background: #151a23;
    position: absolute;
    top: 60px;
    width: 100%;
  }
  .cust_compe_fy {
    font-size: 20px;
    color: #8a8c91;
  }
  .custCont {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 80px 0;
  }
  .custLeft {
    width: 50%;
    display: flex;
    justify-content: left;
    align-items: center;
  }
  .cust_text_Cont {
    width: 80%;
    line-height: 32px;
  }
  .cust_tit {
    font-size: 21px;
    font-weight: 500;
    color: #151a23;
    // line-height: 70px;
  }
  .cust_fy {
    color: #8a8c91;
    margin-bottom: 32px;
  }
  .custRight {
    width: 50%;
  }
  .custRight img {
    width: 100%;
  }
}
</style>
      